import type { MaybeRefOrGetter } from "vue"
import { computed, toValue } from "vue"
import { buildCanonicalUrl } from "@/utils/buildCanonicalUrl"

/**
 * Absolute canonical URL for the current public page, resolved from the jobshop
 * base URL (`jobShopData`) and a page path relative to the jobshop root.
 *
 * `relativePath` is the route slug without a leading slash or query string; an
 * empty path resolves to the jobshop homepage.
 */
export function useCanonicalUrl(relativePath: MaybeRefOrGetter<string> = "") {
  const { data: jobShop } = useNuxtData<JobShop>("jobShopData")

  return computed(() => buildCanonicalUrl(jobShop.value?.jobShopUrl ?? "", toValue(relativePath)))
}
